
import { Component, Mixins, Watch, Prop, Vue } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import ValidateableMixin from '@/mixins/ValidateableMixin';
import { warrantiesAndRefundPolicyURL } from '@/constants/constants';
@Component({
    components: {},
    mixins: [ModelMixin, ValidateableMixin],
})
export default class TermsAndConditionModal extends Mixins<ValidateableMixin, ModelMixin<boolean>>(
    ValidateableMixin,
    ModelMixin,
) {
    @Prop({ type: Function, required: true })
    refresh!: () => void;
    warrantiesAndRefundPolicyURL = warrantiesAndRefundPolicyURL;
}
